const LgpdAdsLightningId = '87';
export default LgpdAdsLightningId;
